import React, {Component} from 'react';
import { BrowserRouter, Switch, Link, Route } from 'react-router-dom'; 
 
import axios from 'axios'; 
import {api_base_url, base_url} from '../common/Constants';

 
class SearchContent extends React.Component{

    constructor(props){
        super(props);

        
        this.state = {
            search : [],
            loading : 1 
        }
    }
 
    componentDidMount()
    {
        
                this.setState({loading:0});
    }

     handleSearch = (e) => {
           
            var data = { search_word : e.target.value}
        
            axios.post(api_base_url+"search", data).then(response=>{
                this.setState({search:response.data}); 
                this.setState({loading:0}); 
                console.log(this.state.search.contents)
            });
        
        }; 
    

    render()
    { 
        if (this.state.loading == 1) {
            return <div>Loading...</div>;
          }
    return (
        <div className='body-block'> 
                    <div className='page-block'> 
 
       <div  data-aos="fade-in" data-aos-duration="1000" class="page-header aos-init aos-animate"><div class="header-filter"></div></div>

       <section className="min-search section-padded">
  <div>
    <div className="ais-InstantSearch">
      {/* SEARCH BOX */}
      <div className="ais-SearchBox">
        <form role="search" className="ais-SearchBox-form" noValidate>
          <input
            type="search"
            className="ais-SearchBox-input"
            placeholder="Search here…"
            aria-label="Search"
            autoCorrect="off"
            autoCapitalize="off"
            autoComplete="off"
            spellCheck={false}
            required
            maxLength={512}
            onChange={this.handleSearch}
          />

          <button
            type="submit"
            title="Search"
            className="ais-SearchBox-submit"
          >
             <svg
    id="b"
    viewBox="0 0 21.23 21.23"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g id="c">
      <path
        style={{ fill: "#eaeaea", fillRule: "evenodd" }}
        d="m14.41,4.23c-2.81-2.81-7.37-2.81-10.18,0-2.81,2.81-2.81,7.37,0,10.18,
           2.81,2.81,7.37,2.81,10.18,0s2.81-7.37,0-10.18h0ZM2.73,2.73C6.37-.91,
           12.27-.91,15.91,2.73c3.39,3.39,3.62,8.73.71,12.39l4.3,4.3c.41.41.41,
           1.09,0,1.5-.41.41-1.09.41-1.5,0l-4.3-4.3c-3.66,2.91-9,2.68-12.39-.71
           C-.91,12.27-.91,6.37,2.73,2.73Z"
      />
    </g>
  </svg>
          </button>
        </form>
      </div>
      {this.state.search.contents && this.state.search.contents.length > 0 &&


       <div className="ais-Hits">
        <div className="custom-hits">
            { this.state.search.contents.map((item, key) => (
          <Link to={`${base_url}${item.slug}`} className="custom-hit">
            <h3>
              <span className="ais-Highlight">{item.title}</span>
              <span className="category"> [Pages] </span>
            </h3>
            <p>{item.description}</p>
          </Link>

            ))} 
        </div>
      </div>

 }

   {this.state.search.services && this.state.search.services.length > 0 &&

       <div className="ais-Hits">
        <div className="custom-hits">
            { this.state.search.services.map((item, key) => (
          <Link to={`${base_url}services/${item.slug}`} className="custom-hit">
            <h3>
              <span className="ais-Highlight">{item.title}</span>
              <span className="category"> [Services] </span>
            </h3>
            <p>{item.description}</p>
          </Link>

            ))} 
        </div>
      </div>

 }

   {this.state.search.news && this.state.search.news.length > 0 &&

       <div className="ais-Hits">
        <div className="custom-hits">
            { this.state.search.news.map((item, key) => (
          <Link to={`${base_url}news-info/${item.slug}`} className="custom-hit">
            <h3>
              <span className="ais-Highlight">{item.title}</span>
              <span className="category"> [Articles] </span>
            </h3>
            <p>{item.description}</p>
          </Link>

            ))} 
        </div>
      </div>

 }

   
 
      
    </div>
  </div>
</section>




        </div>

</div>    
);
}

}

export default SearchContent;